import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import ProposalList from "./ProposalsList";

const ProposalsListPage = () => {
  return (
    <NavHeightAdjust>
      <ProposalList />
    </NavHeightAdjust>
  );
};

export default ProposalsListPage;
